import {
  BG_STYLES,
  COMMON_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { View, Text, Image } from "react-native";
import { DIAGNOSIS_UNDER_PROCESS } from "../assests/images";
import { useTranslation } from "react-i18next";

const DiagnosisUnderProcess = () => {
  const { t } = useTranslation();
  return (
    <View
      style={[
        COMMON_STYLES.justifyCenter,
        COMMON_STYLES.alignItemsCenter,
        BG_STYLES.bgBlack,
        COMMON_STYLES.flex1,
      ]}
    >
      <View
        style={[
          BG_STYLES.bgWhite,
          COMMON_STYLES.p1,
          COMMON_STYLES.alignItemsCenter,
          COMMON_STYLES.justifyCenter,
          COMMON_STYLES.br1,
        ]}
      >
        <Text
          style={[
            TYPOGRAPHY.HEADING3,
            VARIANTS_STYLES.EMPHASIZED,
            COMMON_STYLES.mb1,
          ]}
        >
          {t("diagnosis_under_process")}
        </Text>
        <Image
          source={DIAGNOSIS_UNDER_PROCESS}
          style={[{ width: 200, height: 200 }]}
        />
      </View>
    </View>
  );
};

export default DiagnosisUnderProcess;
